<template>
	<div>
		<el-card class="table-card" shadow="always">
			<div slot="header" class="clearfix">
				<span>规划信息</span>
			</div>
			<el-descriptions :column="2" border>
				<el-descriptions-item label="规划编号">{{ data.planNo }}</el-descriptions-item>
				<el-descriptions-item label="规划类型">
					<el-tag :type="PlanningType[data.planType] || 'default'" size="small">
						{{ $menu.getLabel('PlanningType', data.planType) || '-' }}
					</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="资产编号">{{ data.assetNo }}</el-descriptions-item>
				<el-descriptions-item label="资产名称">{{ data.assetName }}</el-descriptions-item>
				<el-descriptions-item label="所属项目">{{ data.communityName }}</el-descriptions-item>
				<el-descriptions-item label="规划状态">
					<el-tag :type="AssetPlanStatus[data.status] || 'default'" size="small">
						{{ $menu.getLabel('AssetPlanStatus', data.status) || '-' }}
					</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="开始日期">{{ data.startDate }}</el-descriptions-item>
				<el-descriptions-item label="结束日期">{{ data.endDate }}</el-descriptions-item>
				<el-descriptions-item label="责任部门">{{ data.department }}</el-descriptions-item>
				<el-descriptions-item label="责任人">{{ data.responsiblePerson }}</el-descriptions-item>
				<el-descriptions-item label="联系电话">{{ data.contactPhone }}</el-descriptions-item>
				<el-descriptions-item label="预算金额">{{ data.budgetAmount }}</el-descriptions-item>
			</el-descriptions>
			<el-divider></el-divider>
			<div class="remark">
				<div>规划目标：</div>
				<div class="remark-info">{{ data.planTarget }}</div>
			</div>
			<div class="remark">
				<div>执行进度：</div>
				<el-progress style="width: 100%" :percentage="data.progress"></el-progress>
			</div>
			<el-divider></el-divider>
			<div class="remark">
				<div>规划说明：</div>
				<div class="remark-info">{{ data.planDescription }}</div>
			</div>
		</el-card>
		<el-card class="table-card" shadow="always">
			<div slot="header" class="clearfix">
				<span>附件</span>
			</div>
			<div>
				<el-empty :image-size="100" description="暂无附件"></el-empty>
			</div>
		</el-card>
	</div>
</template>

<script>
	import { PlanningType, AssetPlanStatus } from '@/utils/meunType.js';
	export default {
		name: 'AssetPlanBaseInfo',
		props: {
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		data() {
			return { PlanningType, AssetPlanStatus };
		},
		methods: {},
	};
</script>

<style scoped lang="scss">
	.table-card {
		margin-bottom: 15px;
	}

	.remark {
		margin-top: 20px;
		color: #1c1c1c;
		font-size: 14px;
		font-weight: 500;
		&-info {
			margin-top: 8px;
			box-sizing: border-box;
			background-color: #ebebeb;
			width: 100%;
			padding: 10px 12px;
			color: #333;
			border-radius: 5px;
		}
	}

	.depreciation-list {
		display: flex;
		justify-content: space-between;
		align-items: center;
		.depreciation-item {
			display: flex;
			flex-direction: column;
			gap: 6px;
			font-size: 20px;
			color: #1c1c1c;
		}
		.depreciation-item :first-child {
			font-size: 14px;
			color: #666;
		}
	}
</style>
